import api from "./../config";

export const VerifyEmailAPI = async ({ token }) => {
  const response = await api({
    method: "POST",
    url: "api/v1/auth/verify-email",
    data: {
      token,
    },
  });

  return response;
};
